export const baseUrl = 'https://back-test.amaspace.co/api/'
// export const prodUrl = 'https://api.amaspace.co/api/'
// export const testUrl = 'https://back-test.amaspace.co/api/'
// export const serverlessNodeUrl = process.env.NODE_ENV === 'production' ? '' : "https://admin-panel-front-ahdbwa9fm-amaspace.vercel.app";
export const serverlessNodeUrl = ''
